import axios from '../request/http';
import {
  toFormData
} from '../common/descriptions'


const marketing = {
  // 优惠券列表
  couponList(params) {
    return axios.get("/admin/coupon/activity/list", {
      params
    });
  },
  // 优惠券新增
  couponAdd(data) {
    return axios.post("/admin/coupon/activity/add", data);
  },
  // 优惠券活动
  couponList(params) {
    return axios.get("/admin/coupon/activity/list", {
      params
    });
  },
  // 服务套餐列表
  comboList(params) {
    return axios.get("/admin/combo/list", {
      params
    });
  },
  // 服务套餐上下架
  comboUpdateStatus(params) {
    return axios.get("/admin/combo/updateStatus", {
      params
    });
  },
  // 套餐服务详情
  comboDetal(params) {
    return axios.get("/admin/combo/detal", {
      params
    });
  },
  // 套餐服务修改
  comboUpdata(data) {
    return axios.post("/admin/combo/updateDetal", data);
  },
  // 套餐订单列表
  comboOrderList(params) {
    return axios.get("/admin/combo/serviceCombo/list", {
      params
    });
  },
  // 套餐退款
  comboOrderAfter(params) {
    return axios.get("/admin/combo/serviceCombo/after-accept", {
      params
    });
  },
  // 可勾选商品列表
  activityProduct(params) {
    return axios.get("/admin/activity/select/goods/list", {
      params
    });
  },
  // 添加活动商品
  addGoodsProduct(data) {
    return axios.post("/admin/activity/goods/add", data);
  },
  // 商品活动列表
  addGoodsList(params) {
    return axios.get("/admin/activity/goods/list", {
      params
    });
  },
  // 更新活动商品信息
  updataActivityGoods(params) {
    return axios.get("/admin/activity/goods/update", {
      params
    });
  },
  // 置顶商品信息
  topUpActivityGoods(params) {
    return axios.get("/admin/activity/goods/topUp", {
      params
    });
  },
  // 拖拽排序商品信息
  sortActivityGoods(params) {
    return axios.get("/admin/activity/activityGoodsSort", {
      params
    });
  },
  // 易企顺商品订单列表
  yiQishunOrderList(params) {
    return axios.get("/admin/yqs/order/list", {
      params
    });
  },
  // 平台优惠券列表
  activityCouponList(params) {
    return axios.get("/admin/coupon/activity/plate/CouponList", {
      params
    });
  },
  // 平台优惠券新增/编辑
  activityAdd(data) {
    return axios.post("/admin/coupon/activity/plate/add", data);
  },
  // 平台优惠券导入地区表单
  importRegion(data) {
    return axios.post("/admin/coupon/region/import", data);
  },
  // 平台优惠券导入商品表单
  importGoods(data) {
    return axios.post("/admin/goods/region/import", data);
  },
  // 平台优惠券导入用户表单
  importUser(data) {
    return axios.post("/admin/user/user/import", data);
  },
  // 平台优惠券导入指定服务
  importService(data) {
    return axios.post("/admin/coupon/service/import", data);
  },
  // 删除，开启，关闭平台优惠券
  plateUpdateCoupon(params) {
    return axios.get("/admin/coupon/plate/updateCoupon", {
      params
    });
  },
  // 优惠券活动列表
  getCouponcouponActivity(params) {
    return axios.get("/admin/couponActivity/list", {
      params
    });

  },
  // 优惠券活动可添加优惠券列表
  getCouponList(params) {
    return axios.get("/admin/couponActivity/getCouponList", {
      params
    });
  },
  // 新增优惠券活动
  AddCouponList(data) {
    return axios.post("/admin/couponActivity/edit/couponActivity", data);
  },
  // 优惠券活动优惠券移除
  couponListDetele(params) {
    return axios.get("/admin/couponActivity/delCoupon", {
      params
    });
  },
  // 优惠券活动详情
  couponActivityInfo(params) {
    return axios.get("/admin/couponActivity/couponActivity/info", {
      params
    });
  },
  // 查看优惠券活动二维码
  getwxaCode(params) {
    return axios.get("/admin/couponActivity/couponActivity/wxacode", {
      params
    });
  },
  // 优惠券活动绑定优惠券
  bindCoupons(data) {
    return axios.post("/admin/couponActivity/addCoupon", toFormData(data));
  },
  // 查看优惠券活动二维码
  viewCode(params) {
    return axios.get("/admin/couponActivity/couponActivity/wxacode", { params });
  },
  // 优惠券活动状态修改
  updateStatus(params) {
    return axios.get("/admin/couponActivity/updateStatus", { params });
  },

  // 优惠券限制列表
  limitList(params) {
    return axios.get("/admin/CouponLimit/limitList", {
      params
    });
  },
  // 获取数据接口
  importDataList(file, data) {
    return axios.post(file, data);
  },

  // 平台优惠券新增
  platformAdd(data) {
    return axios.post("/admin/coupon/add/platform", data);
  },
  // 平台优惠券编辑
  platformEdit(params) {
    return axios.get("/admin/coupon/getInfo", {
      params
    });
  },
  // 运费模版
  getPostageList(params) {
    return axios.get("/admin/postage/getPostageList", {
      params
    });
  },
  // 运费模版详情
  getPostageInfo(params) {
    return axios.get("/admin/postage/getInfo", {
      params
    });
  },
  // 新增运费模版
  addOrUpdate(params) {
    return axios.post("/admin/postage/addOrUpdate", params);
  },
  // 删除运费模版
  templateDel(params) {
    return axios.get("/admin/postage/del", { params });
  },
  // 全部省市区
  getCityListTree(params) {
    return axios.get("/admin/postage/getCityListTree", {
      params
    });
  }

}

export default marketing;



// WEBPACK FOOTER //
// ./src/api/marketing.js